import classnames from 'classnames';
import React from 'react';
import Table from '../../dashboard/TookiTakiTable/Table';
import style from './index.scss';
import CollapsibleComponent from './CollapsibleComponent';
import TableRow from '../../dashboard/TookiTakiTable/TableRows/TableRow';
import NoDataToDisplay from '../../../../components/NoDataToDisplay';

import {
  returnCombinedInAndOutData,
  returnAdditionalInfoColumnsAndItems
} from './additionalDetailsUtil';

const AdditionalDetailsHeaderPageOne = [
  {
    key: 'transactionName',
    name: 'transactionName'
  },
  {
    key: 'amount_7',
    name: 'amount_7',
    formatNumeric: true,
    isMoney: true,
    showOriginalOnHover: true
  },
  {
    key: 'amount_30',
    name: 'amount_30',
    formatNumeric: true,
    isMoney: true,
    showOriginalOnHover: true
  },
  {
    key: 'amount_90',
    name: 'amount_90',
    formatNumeric: true,
    isMoney: true,
    showOriginalOnHover: true
  }
];

const AdditionalDetailsHeaderPageTwo = [
  {
    key: 'amount_180',
    name: 'amount_180',
    formatNumeric: true,
    isMoney: true,
    showOriginalOnHover: true
  },
  {
    key: 'amount_360',
    name: 'amount_360',
    formatNumeric: true,
    isMoney: true,
    showOriginalOnHover: true
  }
];

/**
 * AlertHistoryHeader
 * @returns {thead}
 * @constructor
 */
const AlertHistoryHeader = ({ offset }) => {
  if (offset === 1) {
    return (
      <thead>
        <tr>
          <th>Transaction Type</th>
          <th colSpan="1">7 Days</th>
          <th colSpan="1">30 Days</th>
          <th colSpan="1">90 Days</th>
          <th colSpan="1">180 Days</th>
          <th colSpan="1">360 Days</th>
        </tr>
        <tr>
          <th style={{ color: 'transparent' }}>
            THISISARANDOMTEXTDON'TTOUCHTHIS
          </th>
          <th>Amount(SGD)</th>
          <th>Amount(SGD)</th>
          <th>Amount(SGD)</th>
          <th>Amount(SGD)</th>
          <th>Amount(SGD)</th>
        </tr>
      </thead>
    );
  }
  return (
    <thead>
      <tr>
        <th>Transaction Type</th>
        <th colSpan="1">7 Days</th>
        <th colSpan="1">30 Days</th>
        <th colSpan="1">90 Days</th>
      </tr>
      <tr>
        <th style={{ color: 'transparent' }}>
          THISISARANDOMTEXTDON'TTOUCHTHIS
        </th>
        <th>Amount(SGD)</th>
        <th>Amount(SGD)</th>
        <th>Amount(SGD)</th>
      </tr>
    </thead>
  );
};
/**
 * getProcessedAdditionalInfoData segregate data into multiple account type
 * @param data
 * @returns {[]|*[]}
 */
const getProcessedAdditionalInfoData = (data) => {
  const formattedAdditionalInfoData = {
    cash: {},
    nonCash: {},
    remittance: {}
  };

  if (Array.isArray(data)) {
    // filter every transaction type
    const filteredCash = data.filter(
      (currentItem) =>
        String(currentItem.transactionType).toUpperCase().trim() === 'CASH'
    );

    const filteredNonCash = data.filter(
      (currentItem) =>
        String(currentItem.transactionType).toUpperCase().trim() === 'NON-CASH'
    );

    const filteredRemittance = data.filter(
      (currentItem) =>
        String(currentItem.transactionType).toUpperCase().trim() ===
        'REMITTANCE'
    );

    // specify properties for each transaction type
    filteredCash.forEach((currentItem) => {
      const { lookbackDays = 0, operationType = '', value = 0 } = currentItem;
      formattedAdditionalInfoData.cash[
        `${operationType}_${lookbackDays}`
      ] = value;
    });

    filteredNonCash.forEach((currentItem) => {
      const { lookbackDays = 0, operationType = '', value = 0 } = currentItem;
      formattedAdditionalInfoData.nonCash[
        `${operationType}_${lookbackDays}`
      ] = value;
    });

    filteredRemittance.forEach((currentItem) => {
      const { lookbackDays = 0, operationType = '', value = 0 } = currentItem;
      formattedAdditionalInfoData.remittance[
        `${operationType}_${lookbackDays}`
      ] = value;
    });

    // add averageAmount to each transaction type

    if (filteredCash.length > 0) {
      let totalAmount_7 = 0;
      let count_7 = 0;

      let totalAmount_30 = 0;
      let count_30 = 0;

      let totalAmount_90 = 0;
      let count_90 = 0;

      let totalAmount_180 = 0;
      let count_180 = 0;

      let totalAmount_360 = 0;
      let count_360 = 0;
      filteredCash.forEach((currentItem) => {
        const { lookbackDays = 0, operationType = '', value = 0 } = currentItem;

        if (`${operationType}_${lookbackDays}` === 'totalAmount_7') {
          totalAmount_7 = value;
        }

        if (`${operationType}_${lookbackDays}` === 'count_7') {
          count_7 = value;
        }

        if (`${operationType}_${lookbackDays}` === 'totalAmount_30') {
          totalAmount_30 = value;
        }

        if (`${operationType}_${lookbackDays}` === 'count_30') {
          count_30 = value;
        }

        if (`${operationType}_${lookbackDays}` === 'totalAmount_90') {
          totalAmount_90 = value;
        }

        if (`${operationType}_${lookbackDays}` === 'count_90') {
          count_90 = value;
        }

        if (`${operationType}_${lookbackDays}` === 'totalAmount_180') {
          totalAmount_180 = value;
        }

        if (`${operationType}_${lookbackDays}` === 'count_180') {
          count_180 = value;
        }

        if (`${operationType}_${lookbackDays}` === 'totalAmount_360') {
          totalAmount_360 = value;
        }

        if (`${operationType}_${lookbackDays}` === 'count_360') {
          count_360 = value;
        }
      });

      formattedAdditionalInfoData.cash['averageAmount_7'] =
        totalAmount_7 / count_7;
      formattedAdditionalInfoData.cash['averageAmount_30'] =
        totalAmount_30 / count_30;
      formattedAdditionalInfoData.cash['averageAmount_90'] =
        totalAmount_90 / count_90;
      formattedAdditionalInfoData.cash['averageAmount_180'] =
        totalAmount_180 / count_180;
      formattedAdditionalInfoData.cash['averageAmount_360'] =
        totalAmount_360 / count_360;
    }

    if (filteredNonCash.length > 0) {
      let totalAmount_7 = 0;
      let count_7 = 0;

      let totalAmount_30 = 0;
      let count_30 = 0;

      let totalAmount_90 = 0;
      let count_90 = 0;

      let totalAmount_180 = 0;
      let count_180 = 0;

      let totalAmount_360 = 0;
      let count_360 = 0;
      filteredNonCash.forEach((currentItem) => {
        const { lookbackDays = 0, operationType = '', value = 0 } = currentItem;

        if (`${operationType}_${lookbackDays}` === 'totalAmount_7') {
          totalAmount_7 = value;
        }

        if (`${operationType}_${lookbackDays}` === 'count_7') {
          count_7 = value;
        }

        if (`${operationType}_${lookbackDays}` === 'totalAmount_30') {
          totalAmount_30 = value;
        }

        if (`${operationType}_${lookbackDays}` === 'count_30') {
          count_30 = value;
        }

        if (`${operationType}_${lookbackDays}` === 'totalAmount_90') {
          totalAmount_90 = value;
        }

        if (`${operationType}_${lookbackDays}` === 'count_90') {
          count_90 = value;
        }

        if (`${operationType}_${lookbackDays}` === 'totalAmount_180') {
          totalAmount_180 = value;
        }

        if (`${operationType}_${lookbackDays}` === 'count_180') {
          count_180 = value;
        }

        if (`${operationType}_${lookbackDays}` === 'totalAmount_360') {
          totalAmount_360 = value;
        }

        if (`${operationType}_${lookbackDays}` === 'count_360') {
          count_360 = value;
        }
      });

      formattedAdditionalInfoData.nonCash['averageAmount_7'] =
        totalAmount_7 / count_7;
      formattedAdditionalInfoData.nonCash['averageAmount_30'] =
        totalAmount_30 / count_30;
      formattedAdditionalInfoData.nonCash['averageAmount_90'] =
        totalAmount_90 / count_90;
      formattedAdditionalInfoData.nonCash['averageAmount_180'] =
        totalAmount_180 / count_180;
      formattedAdditionalInfoData.nonCash['averageAmount_360'] =
        totalAmount_360 / count_360;
    }

    if (filteredRemittance.length > 0) {
      let totalAmount_7 = 0;
      let count_7 = 0;

      let totalAmount_30 = 0;
      let count_30 = 0;

      let totalAmount_90 = 0;
      let count_90 = 0;

      let totalAmount_180 = 0;
      let count_180 = 0;

      let totalAmount_360 = 0;
      let count_360 = 0;
      filteredRemittance.forEach((currentItem) => {
        const { lookbackDays = 0, operationType = '', value = 0 } = currentItem;

        if (`${operationType}_${lookbackDays}` === 'totalAmount_7') {
          totalAmount_7 = value;
        }

        if (`${operationType}_${lookbackDays}` === 'count_7') {
          count_7 = value;
        }

        if (`${operationType}_${lookbackDays}` === 'totalAmount_30') {
          totalAmount_30 = value;
        }

        if (`${operationType}_${lookbackDays}` === 'count_30') {
          count_30 = value;
        }

        if (`${operationType}_${lookbackDays}` === 'totalAmount_90') {
          totalAmount_90 = value;
        }

        if (`${operationType}_${lookbackDays}` === 'count_90') {
          count_90 = value;
        }

        if (`${operationType}_${lookbackDays}` === 'totalAmount_180') {
          totalAmount_180 = value;
        }

        if (`${operationType}_${lookbackDays}` === 'count_180') {
          count_180 = value;
        }

        if (`${operationType}_${lookbackDays}` === 'totalAmount_360') {
          totalAmount_360 = value;
        }

        if (`${operationType}_${lookbackDays}` === 'count_360') {
          count_360 = value;
        }
      });

      formattedAdditionalInfoData.remittance['averageAmount_7'] =
        totalAmount_7 / count_7;
      formattedAdditionalInfoData.remittance['averageAmount_30'] =
        totalAmount_30 / count_30;
      formattedAdditionalInfoData.remittance['averageAmount_90'] =
        totalAmount_90 / count_90;
      formattedAdditionalInfoData.remittance['averageAmount_180'] =
        totalAmount_180 / count_180;
      formattedAdditionalInfoData.remittance['averageAmount_360'] =
        totalAmount_360 / count_360;
    }

    // build array of data
    const formattedData = [];

    // push 'Average - Cash'
    formattedData.push({
      ...formattedAdditionalInfoData.cash,
      transactionName: 'Average - Cash',
      amount_7: formattedAdditionalInfoData.cash.averageAmount_7,
      amount_30: formattedAdditionalInfoData.cash.averageAmount_30,
      amount_90: formattedAdditionalInfoData.cash.averageAmount_90,
      amount_180: formattedAdditionalInfoData.cash.averageAmount_180,
      amount_360: formattedAdditionalInfoData.cash.averageAmount_360
    });

    // push 'Max - Cash'
    formattedData.push({
      ...formattedAdditionalInfoData.cash,
      transactionName: 'Max - Cash',
      amount_7: formattedAdditionalInfoData.cash.maxAmount_7,
      amount_30: formattedAdditionalInfoData.cash.maxAmount_30,
      amount_90: formattedAdditionalInfoData.cash.maxAmount_90,
      amount_180: formattedAdditionalInfoData.cash.maxAmount_180,
      amount_360: formattedAdditionalInfoData.cash.maxAmount_360
    });

    // push 'Average - Non Cash'
    formattedData.push({
      ...formattedAdditionalInfoData.nonCash,
      transactionName: 'Average - Non Cash',
      amount_7: formattedAdditionalInfoData.nonCash.averageAmount_7,
      amount_30: formattedAdditionalInfoData.nonCash.averageAmount_30,
      amount_90: formattedAdditionalInfoData.nonCash.averageAmount_90,
      amount_180: formattedAdditionalInfoData.nonCash.averageAmount_180,
      amount_360: formattedAdditionalInfoData.nonCash.averageAmount_360
    });

    // push 'Max - Non Cash'
    formattedData.push({
      ...formattedAdditionalInfoData.nonCash,
      transactionName: 'Max - Non Cash',
      amount_7: formattedAdditionalInfoData.nonCash.maxAmount_7,
      amount_30: formattedAdditionalInfoData.nonCash.maxAmount_30,
      amount_90: formattedAdditionalInfoData.nonCash.maxAmount_90,
      amount_180: formattedAdditionalInfoData.nonCash.maxAmount_180,
      amount_360: formattedAdditionalInfoData.nonCash.maxAmount_360
    });

    // push 'Average - Remittance'
    formattedData.push({
      ...formattedAdditionalInfoData.remittance,
      transactionName: 'Average - Remittance',
      amount_7: formattedAdditionalInfoData.remittance.averageAmount_7,
      amount_30: formattedAdditionalInfoData.remittance.averageAmount_30,
      amount_90: formattedAdditionalInfoData.remittance.averageAmount_90,
      amount_180: formattedAdditionalInfoData.remittance.averageAmount_180,
      amount_360: formattedAdditionalInfoData.remittance.averageAmount_360
    });

    // push 'Max - Remittance'
    formattedData.push({
      ...formattedAdditionalInfoData.remittance,
      transactionName: 'Max - Remittance',
      amount_7: formattedAdditionalInfoData.remittance.maxAmount_7,
      amount_30: formattedAdditionalInfoData.remittance.maxAmount_30,
      amount_90: formattedAdditionalInfoData.remittance.maxAmount_90,
      amount_180: formattedAdditionalInfoData.remittance.maxAmount_180,
      amount_360: formattedAdditionalInfoData.remittance.maxAmount_360
    });

    return formattedData;
  }

  return [];
};

/**
 * AdditionalDetails component
 */
class AdditionalDetails extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      inData: [],
      outData: [],
      transactionTypes: null,
      inTransactionExpanded: false,
      outTransactionExpanded: false,

      columnOffset: 0,
      expandedRows: []
    };
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (nextProps.transactionTypes) {
      this.setState({ transactionTypes: nextProps.transactionTypes });
    }
    if (Object.keys(nextProps.data).length !== 0) {
      if (nextProps.data.activityDetailsTxnAdditionalInfo) {
        const txtTypeData = JSON.parse(
          nextProps.data.activityDetailsTxnAdditionalInfo
        );

        let inData = [];
        let outData = [];

        if (Array.isArray(txtTypeData)) {
          txtTypeData.forEach((currentTransactionComponentData) => {
            if (currentTransactionComponentData) {
              const {
                componentName = '',
                componentDetails = []
              } = currentTransactionComponentData;

              if (String(componentName).toUpperCase().trim() === 'IN') {
                inData = componentDetails;
              }

              if (String(componentName).toUpperCase().trim() === 'OUT') {
                outData = componentDetails;
              }
            }
          });
        }

        const inDataObject = getProcessedAdditionalInfoData(inData);
        const outDataObject = getProcessedAdditionalInfoData(outData);

        this.setState({ inData: inDataObject, outData: outDataObject });
      }
    }
  }

  onClickNextPeriod = () => {
    this.setState({
      columnOffset: 1
    });
  };

  onClickPreviousPeriod = () => {
    this.setState({
      columnOffset: 0
    });
  };

  isCCExpanded = (indexExpanded) => {
    if (indexExpanded === 0) {
      this.setState({
        inTransactionExpanded: !this.state.inTransactionExpanded
      });
    }
    if (indexExpanded === 1) {
      this.setState({
        outTransactionExpanded: !this.state.outTransactionExpanded
      });
    }
  };

  toggleRow = (index) => {
    const { expandedRows } = this.state;
    if (expandedRows.filter((item) => item === index).length > 0) {
      this.setState({
        expandedRows: expandedRows.filter((item) => item !== index)
      });
    } else {
      this.setState({
        expandedRows: [...expandedRows, index]
      });
    }
  };

  renderAdditionalInfoWithoutSettings = () => {
    const {
      inData,
      outData,
      inTransactionExpanded,
      outTransactionExpanded,
      columnOffset
    } = this.state;

    const { alertDetail } = this.props;
    const inDataView =
      inData.length > 0 &&
      inTransactionExpanded &&
      inData.map((tableRow) => {
        return (
          <TableRow
            associatedObject={alertDetail}
            keys={
              columnOffset === 0
                ? AdditionalDetailsHeaderPageOne
                : [
                    ...AdditionalDetailsHeaderPageOne,
                    ...AdditionalDetailsHeaderPageTwo
                  ]
            }
            tableRowData={tableRow}
          />
        );
      });
    const outDataView =
      outData.length > 0 &&
      outTransactionExpanded &&
      outData.map((tableRow) => {
        return (
          <TableRow
            associatedObject={alertDetail}
            keys={
              columnOffset === 0
                ? AdditionalDetailsHeaderPageOne
                : [
                    ...AdditionalDetailsHeaderPageOne,
                    ...AdditionalDetailsHeaderPageTwo
                  ]
            }
            tableRowData={tableRow}
          />
        );
      });
    return [
      <CollapsibleComponent
        index={0}
        title={'In Transaction'}
        data={inData}
        isExpanded={this.isCCExpanded}>
        {inData.length === 0 && <NoDataToDisplay />}
      </CollapsibleComponent>,
      inDataView,
      <CollapsibleComponent
        index={1}
        title={'Out Transaction'}
        data={outData}
        isExpanded={this.isCCExpanded}>
        {outData.length === 0 && <NoDataToDisplay />}
      </CollapsibleComponent>,
      outDataView
    ];
  };

  renderAdditionalInfoColumn = (column, index) => {
    const { inData, outData, expandedRows, columnOffset } = this.state;
    const isExpanded = expandedRows.filter((item) => item === index).length > 0;
    const { alertDetail } = this.props;

    const collapsibleRow = (
      <CollapsibleComponent
        index={index}
        title={column.columnName}
        data={column.items}
        isExpanded={this.toggleRow}>
        {column.items.length === 0 && <NoDataToDisplay />}
      </CollapsibleComponent>
    );
    const renderedItems =
      column.items.length > 0 &&
      isExpanded &&
      column.items.map((tableRow) => {
        return (
          <TableRow
            associatedObject={alertDetail}
            keys={
              columnOffset === 0
                ? AdditionalDetailsHeaderPageOne
                : [
                    ...AdditionalDetailsHeaderPageOne,
                    ...AdditionalDetailsHeaderPageTwo
                  ]
            }
            tableRowData={tableRow}
          />
        );
      });

    return [collapsibleRow, renderedItems];
  };

  renderAdditionalInfo = () => {
    const { inData, outData } = this.state;
    const { settings } = this.props;
    if (settings) {
      const combinedData = returnCombinedInAndOutData(inData, outData);

      const parsedDataWithSettings = returnAdditionalInfoColumnsAndItems(
        combinedData,
        settings
      );

      return parsedDataWithSettings.map((item, itemIndex) =>
        this.renderAdditionalInfoColumn(item, itemIndex)
      );
    }

    return this.renderAdditionalInfoWithoutSettings();
  };

  render() {
    const { inData, outData, columnOffset } = this.state;
    const combinedData = returnCombinedInAndOutData(inData, outData);

    let sectionHeader = (
      <div className={classnames('row', style.primaryTableHead)}>
        <div className="col-md-10">
          <span className={style.assocTitle}>Additional Information</span>
        </div>
        <div className="col-md-2">
          <div style={{ display: 'inline-block' }}>
            {columnOffset !== 0 && (
              <div
                onClick={this.onClickPreviousPeriod}
                className={style.headerButtons}>
                <i className="fa fa-angle-left" />
              </div>
            )}
            <div
              onClick={this.onClickNextPeriod}
              className={style.headerButtons}>
              <i className="fa fa-angle-right" />
            </div>
          </div>
        </div>
      </div>
    );

    let renderedView = (
      <div className={classnames(style.card, 'mt-3')}>
        <div className={classnames(style.sectionHeader)}>{sectionHeader}</div>
        <div></div>
        <div className={classnames(style.card_body)}>
          <Table isStriped={true}>
            <AlertHistoryHeader offset={columnOffset} />
            <tbody>{this.renderAdditionalInfo()}</tbody>
          </Table>
        </div>
      </div>
    );

    return <div>{renderedView}</div>;
  }
}

AdditionalDetails.propTypes = {};
export default AdditionalDetails;
